<template>
  <div v-if="viewdata.type === 'glselectionchange'">
    <div class="d-flex flex-column gap-4">
      <v-row v-if="viewdata.network_detail?.name" no-gutters class="align-center">
        <v-col cols="12" sm="3" class="details-label">
          {{ $nova.labelsName('approvals_page','division_label','Network') }}
        </v-col>
        <v-col cols="12" sm="9" class="details-value font-weight-bold">
          {{ viewdata.network_detail.name }}
        </v-col>
      </v-row>

      <v-row v-if="(viewdata.periods || []).length" no-gutters class="align-center">
        <v-col cols="12" sm="3" class="details-label">
          Applicable {{$nova.labelsName('approvals_page','month_label','Period') }}
        </v-col>
        <v-col cols="12" sm="9" class="details-value font-weight-bold">
          <div class="selected-months">
            <ul>
              <li v-for="(month, index) in viewdata.periods" :key="index" class='month-item'>
                  {{ month }}
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
      <div v-if="viewdata.reportingunit_detail && viewdata.reportingunit_detail.length">
        <div class="font-weight-regular">Selected {{$nova.labelsName('approvals_page','ru_entity_plural_label','Reporting Units')}}</div>
        <div label
          class="mr-1 border-on pr-2 radius-small  d-flex align-center justify-space-between all-width mb-2 pl-0"
          outlined :key="k" v-for="(v,k) in viewdata.reportingunit_detail">
          <v-chip label class="mr-2"><span class="noTransform">{{v.code}}</span></v-chip>
          <span class="noTransform">{{v.name}}</span>
          <v-spacer></v-spacer>
          <v-icon
            v-if="proccesed_cycle?.includes(v._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 ) "
            color="success">mdi-check-circle</v-icon>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <lb-datatablenew :headers="glselectionheaders" :items="glDetailsWithSNo"
        :enableslot="['selected_sl', 'period','datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional','management_thresholds_amount_regional','management_thresholds_percent_regional','floor_management_thresholds_amount_regional']">
        <template v-slot:selected_sl="{ item }">
          <div class="text-left">
            {{ item.selected_sl ? 'Selected' : 'Un-Selected' }}
          </div>
        </template>
        <template v-slot:period="{ item }">
          <div class="text-center" v-if="item.period">
            {{ item?.period || 'All' }}</div>
          <div class="text-center" v-else>-</div>
        </template>
        <template v-slot:datatypes="">
          <div class='ellipsis-on text-left noTransform'>
            vs {{ proformaLabel }}
          </div>
          <div class='ellipsis-on text-left noTransform'>
            vs {{ forecastLabel }}
          </div>
        </template>
        <template v-slot:control_thresholds_amount="{ item }">
          <div class="text-right" v-if="item.control_thresholds_amount_proforma || item.control_thresholds_amount_proforma === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.control_thresholds_amount_forecast || item.control_thresholds_amount_forecast === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_percent="{ item }">
          <div class="text-right" v-if="item.control_thresholds_percent_proforma || item.control_thresholds_percent_proforma === 0">
            {{ item.control_thresholds_percent_proforma || 0 }}%</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.control_thresholds_percent_forecast || item.control_thresholds_percent_forecast === 0">
            {{ item.control_thresholds_percent_forecast || 0 }}%</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_amount="{ item }">
          <div class="text-right" v-if="item.management_thresholds_amount_proforma || item.management_thresholds_amount_proforma === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_proforma) }}</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.management_thresholds_amount_forecast || item.management_thresholds_amount_forecast === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_forecast) }}</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_percent="{ item }">
          <div class="text-right" v-if="item.management_thresholds_percent_proforma || item.management_thresholds_percent_proforma === 0">
            {{ item.management_thresholds_percent_proforma || 0 }}%</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.management_thresholds_percent_forecast || item.management_thresholds_percent_forecast === 0">
            {{ item.management_thresholds_percent_forecast || 0 }}%</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_amount_regional="{ item }">
          <div class="text-right" v-if="item.control_thresholds_amount_regional_proforma || item.control_thresholds_amount_regional_proforma === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) || 0 }}</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.control_thresholds_amount_regional_forecast || item.control_thresholds_amount_regional_forecast === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) || 0}}</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_percent_regional="{ item }">
          <div class="text-right" v-if="item.control_thresholds_percent_regional_proforma || item.control_thresholds_percent_regional_proforma === 0">
            {{ item.control_thresholds_percent_regional_proforma }}%</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.control_thresholds_percent_regional_forecast || item.control_thresholds_percent_regional_forecast === 0">
            {{ item.control_thresholds_percent_regional_forecast }}%</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_amount_regional="{ item }">
          <div class="text-right" v-if="item.management_thresholds_amount_regional_proforma || item.management_thresholds_amount_regional_proforma === 0">
            {{ item.management_thresholds_amount_regional_proforma }}</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.management_thresholds_amount_regional_forecast || item.management_thresholds_amount_regional_forecast === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
          <div class="text-right" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_percent_regional="{ item }">
          <div class="text-right" v-if="item.management_thresholds_percent_regional_proforma || item.management_thresholds_percent_regional_proforma === 0">
            {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
          <div class="text-right" v-else>-</div>
          <div class="text-right" v-if="item.management_thresholds_percent_regional_forecast || item.management_thresholds_percent_regional_forecast === 0">
            {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
          <div class="text-right" v-else>-</div>
        </template>
      </lb-datatablenew>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalGlSelectionChange',
  props: {
    viewdata: {
      type: Object,
      required: true
    },
    gldata: {
      type: Object,
      default: () => ({})
    },
    proccesed_cycle: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      glselectionheaders: [
        { text: this.$nova.labelsName('approvals_page','s_no_label','S.No'), value: 's_no', sortable: false, width: '50px', class: 'sticky-header' },
        { text: this.$nova.labelsName('approvals_page','gl_code_label','GL Code'), value: 'code', sortable: false, width: '100px', class: 'sticky-header' },
        { text: this.$nova.labelsName('approvals_page','gl_name_label','GL Name'), value: 'name', sortable: false, width: '200px', class: 'sticky-header' },
        { text: this.$nova.labelsName('approvals_page','selection_label','Drill-down Selection'), value: 'selected_sl', sortable: false, width: '100px', class: 'sticky-header' },
      ]
    }
  },
  computed: {
    glDetailsWithSNo() {
      return (this.viewdata.gldetail || []).map((item, index) => ({
        ...item,
        s_no: index + 1
      }));
    },
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    forecastLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  }
}
</script>

<style>
  .details-label {
    color: var(--grey-600);
    font-size: 14px;
    font-weight: 500;
  }
  .details-value {
    color: var(--grey-900);
    font-size: 14px;
  }
  .selected-months {
    margin-top: 0px;
  }
  .selected-months ul {
    display: flex;
    flex-wrap: wrap; /* Allows items to wrap to the next line */
    padding: 0;
    margin: 0;
    list-style-type: none; /* Remove default list styling */
    gap: 8px; /* Space between items */
  }
  .month-item {
    display: flex;
    align-items: center;
    padding: 8px;
    background-color: #ecf4f5; /* Background color for items */
    border-radius: 4px;
    font-size: var(--font-size-xs);
    color: var(--blue-500);
    font-weight: 400;
  }
</style>